import { useLazyQuery } from "@apollo/client";
import { useEffect } from "react";
import {
  GetJunctionWithOutTokenResult,
  GetJunctionWithOutTokenVar,
} from "./queries/types";
import { GetJunctionWithOutToken } from "./queries/queries";

import ArcadisLogo from "../../../../../../images/Arcadis_Logo.png";
import TransformLogo from "../../../../../../images/TransformLogo.svg";
import TransformImage from "../../../../../../images/transForm.png";
import EduateLogo from "../../../../../../images/EduateLogo.svg";
import JunctionLogo from "../../../../../../images/ItemIcons/junction.svg";
import PhoneImage from "../../../../../../images/call.svg";
import useUrlParams from "../../../../../../customHooks/useUrlParams";

const JunctionDataForResponsive = () => {
  const { junctionID } = useUrlParams();

  const [getJunctionWithOutToken, { data: junctionData }] = useLazyQuery<
    GetJunctionWithOutTokenResult,
    GetJunctionWithOutTokenVar
  >(GetJunctionWithOutToken);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (junctionID) {
          getJunctionWithOutToken({
            variables: {
              token: "mobileToken",
              junctionId: junctionID ? junctionID : 0,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [junctionID, getJunctionWithOutToken]);

  if (junctionData) {
    return (
      <div className="junction-data-responsive">
        {/* <b className="junction-data-responsive__title">
          Traffic Signal Details
        </b> */}

        <div className="junction-data-responsive__company">
          <img src={TransformImage} alt="" />
          <b>
            {junctionData
              ? junctionData.GetJunctionWithOutToken.customer.name
              : ""}
          </b>
        </div>

        <div className="junction-data-responsive__code">
          <img src={JunctionLogo} alt="" />
          <div>
            <span>Traffic Signal ID</span>
            <b>
              {junctionData ? junctionData.GetJunctionWithOutToken.code : ""}
            </b>
          </div>
        </div>
    
        <div className="junction-data-responsive__block">

          <div className="junction-data-responsive__block--grid">
            <label>Junction Name</label>
            <span>:</span>
            <b> {junctionData ? junctionData.GetJunctionWithOutToken.name : ""}
              {junctionData && junctionData.GetJunctionWithOutToken?.alias
              ? `(${junctionData.GetJunctionWithOutToken.alias})`
              : ""}
            </b>
          </div>
          <div className="junction-data-responsive__block--grid">
            <label>PS Limit</label>
            <span>:</span>
            <b>
              {junctionData
                ? junctionData.GetJunctionWithOutToken?.site?.name
                : ""}
            </b>
          </div>
          <div className="junction-data-responsive__block--grid">
            <label>Traffic Signal Type</label>
            <span>:</span>
            <b>
              {junctionData ? junctionData.GetJunctionWithOutToken.jType : ""}
            </b>
          </div>
          <div className="junction-data-responsive__block--grid">
            <label>Number of Arms</label>
            <span>:</span>
            <b className="number-text">
              {junctionData ? junctionData.GetJunctionWithOutToken.arms : ""}
            </b>
          </div>

          {/* <div className="junction-data-responsive__block--grid">
            <label>Number of Poles</label>
            <span>:</span>
            <b className="number-text">
              {junctionData ? junctionData.GetJunctionWithOutToken.poles : ""}
            </b>
          </div> */}

          <div className="junction-data-responsive__block--grid">
            <label>Location</label>
            <span>:</span>
            <b>
              {junctionData
                ? junctionData.GetJunctionWithOutToken.latitude
                : ""}{" "}
              ,{" "}
              {junctionData
                ? junctionData.GetJunctionWithOutToken.longitude
                : ""}
            </b>
          </div>

          <div className="junction-data-responsive__block--grid">
            <label>Maintained By</label>
            <span>:</span>
            <b>
              {junctionData
                ? junctionData.GetJunctionWithOutToken?.vendorDetails?.desc
                : ""}
            </b>
          </div>

          <div className="junction-data-responsive__block--contact">
            <b>
              Contact <img src={PhoneImage} alt="" className="phone-image" />
            </b>

            <div className="junction-data-responsive__block--contact--grid">
              <label>Station Landline No.</label>
              <span>:</span>

              <b>
                {junctionData?.GetJunctionWithOutToken?.site
                  ?.contactPersonMobile ? (
                  <a
                    href={`tel:${junctionData.GetJunctionWithOutToken.site.contactPersonMobile.replace(/\s+/g, "")}`}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {
                      junctionData.GetJunctionWithOutToken.site
                        .contactPersonMobile
                    }
                  </a>
                ) : (
                  ""
                )}
              </b>

              <span>Helpdesk </span>
              <span>:</span>
              <a href="tel:08022942926">
                <b>080 2294 2926</b>
              </a>
            </div>
          </div>
        </div>
        <div className="junction-data-responsive__footer">
          <div className="junction-data-responsive__footer--flex">
              <div>
                <img src={TransformLogo} alt="" />
                <b>TRANSFORM</b>
              </div>
            <div>
              <img src={ArcadisLogo} alt="" /> <b>ARCADIS</b>
            </div>
          </div>
          {/* <div className="junction-data-responsive__footer--powered-by">
            <b className="junction-data-responsive__footer--powered-by--title">
              Powered by
            </b>
            <div className="junction-data-responsive__footer--powered-by--flex">
              <div>
                <img src={EduateLogo} alt="" /> <span>My-Eduate</span>
              </div>
              <div>
                <img src={TransformLogo} alt="" className="transform-logo" />{" "}
                <span>Transform</span>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    );
  } else {
    return <>No data found</>;
  }
};

export default JunctionDataForResponsive;
